/* --------------------------------------------------------------------------------------
   expenses.service.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class expensesService {
  /* @ngInject */
  constructor(persistService, apiClientService) {
    this.persistService = persistService;
    this.apiClientService = apiClientService;
  }

  getExpensesAmounts(user) {
    const expenses = this.persistService.getObject("clioExpenses");

    if (!expenses) return this.getEmptyExpensesObject(user);

    const userExpenses = expenses.find((item) => item.user == user);

    if (!userExpenses) return this.getEmptyExpensesObject(user);

    return userExpenses;
  }

  setExpensesAmounts(userExpenses) {
    let expenses = this.persistService.getObject("clioExpenses");
    if (!expenses) expenses = [];
    let savedUserExpenses = expenses.find(
      (item) => item.user == userExpenses.user
    );

    if (savedUserExpenses)
      expenses = expenses.filter((item) => item.user != userExpenses.user);

    expenses.push(userExpenses);
    this.persistService.setObject("clioExpenses", expenses);
  }

  getEmptyExpensesObject(user) {
    return {
      user: user,
      enabled: false,
      scan: "",
      print: "",
    };
  }

  async sendExpenses(type, matter, count, user) {
    const userExpenses = this.getExpensesAmounts(user.ID);
    if (userExpenses.enabled) {
      const postdata = {
        ExpenseType: type,
        MatterID: matter.ID,
        Rate: userExpenses[type],
        Quantity: count,
      };
      await this.apiClientService.post("/expense", postdata);
    }
  }

  isEnabled(user) {
    const userExpenses = this.getExpensesAmounts(user.ID);
    return userExpenses.enabled;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/expenses.service.js